// translation.service.ts
// Place this file at: src/app/shared/html-editor/translation/translation.service.ts

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface TranslationResponse {
  translatedText: string;
  sourceLanguage: string;
  targetLanguage: string;
}

export interface DetectLanguageResponse {
  detectedLanguage: string;
}

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private apiUrl = `${environment.apiUrl}/translation`; // Adjust based on your backend URL

  constructor(private http: HttpClient) {}

  translateText(text: string, targetLanguage: 'en' | 'es'): Observable<TranslationResponse> {
    return this.http.post<TranslationResponse>(`${this.apiUrl}/translate`, {
      text,
      targetLanguage
    }).pipe(
      catchError(error => {
        console.error('Translation error:', error);
        return throwError(() => new Error(error.error?.message || 'Translation failed'));
      })
    );
  }

  detectLanguage(text: string): Observable<DetectLanguageResponse> {
    return this.http.post<DetectLanguageResponse>(`${this.apiUrl}/detect-language`, {
      text
    }).pipe(
      catchError(error => {
        console.error('Language detection error:', error);
        return throwError(() => new Error(error.error?.message || 'Language detection failed'));
      })
    );
  }
}